module.exports = {
  name: 'Pricing Plans',

  wizard: {
    actionBtn: 'Save',
    action: 'add_client_type',
    pages: [
      {
        title: 'Pricing Plans',
        subtitle: 'Configure new pricing plan',
        forms: [
          {
            type: 'text',
            form_type: 'text',
            label: 'Plan Name',
            model: 'planName',
            validation: 'required|min:3|max:150',
            class: 'col-12 col-md-6'
          },
          {
            type: 'textarea',
            form_type: 'text',
            label: 'Description',
            model: 'planDescription',
            validation: 'required|min:10|max:500',
            class: 'col-12'
          },
          {
            type: 'select',
            form_type: 'select',
            label: 'Plan Type',
            model: 'planType',
            validation: 'required',
            class: 'col-12 col-md-6',
            options: [
              { value: 'PAID', label: 'Paid' },
              { value: 'FREE', label: 'Free' }
            ]
          },
          {
            type: 'select',
            form_type: 'select',
            label: 'Entity',
            model: 'planUserType',
            validation: 'required',
            class: 'col-12 col-md-6',
            options: [
              { value: 'UNDERWRITER', label: 'Underwriter' },
              { value: 'INTERMEDIARY', label: 'Intermediary' },
              { value: 'CLIENT', label: 'Client' },
              { value: 'SERVICE_PROVIDER', label: 'Service Provider' }
            ]
          },
          {
            type: 'select',
            form_type: 'select',
            label: 'Period Unit',
            model: 'freeAccessPeriod.periodUnit',
            validation: 'required',
            class: 'col-12 col-md-6',
            options: [
              { value: 'DAY', label: 'Day' },
              { value: 'WEEK', label: 'Week' },
              { value: 'MONTH', label: 'Month' },
              { value: 'YEAR', label: 'Year' }
            ],
            conditions: { field: 'planType', value: 'FREE' }
          },
          {
            type: 'number',
            form_type: 'number',
            label: 'Period',
            model: 'freeAccessPeriod.period',
            validation: 'required|min:1',
            class: 'col-12 col-md-6',
            conditions: { field: 'planType', value: 'FREE' }
          },
          {
            type: 'select',
            form_type: 'select',
            label: 'Billing Type',
            model: 'billingDetails.billingType',
            validation: 'required',
            class: 'col-12 col-md-6',
            options: [
              { value: 'ONCE', label: 'Once' },
              { value: 'RECURRING', label: 'Recurring' },
              { value: 'TIERED', label: 'Tiered' }
            ],
            conditions: { field: 'planType', value: 'PAID' }
          },
          {
            type: 'number',
            form_type: 'number',
            label: 'Charge Amount',
            model: 'billingDetails.oneOffCharges[].amount',
            validation: 'required|min:0',
            class: 'col-12 col-md-6',
            conditions: { field: 'billingDetails.billingType', value: 'ONCE' },
            repeat: true
          },
          {
            type: 'text',
            form_type: 'text',
            label: 'Charge Label',
            model: 'billingDetails.oneOffCharges[].label',
            validation: 'required',
            class: 'col-12 col-md-6',
            conditions: { field: 'billingDetails.billingType', value: 'ONCE' },
            repeat: true
          },
          {
            type: 'number',
            form_type: 'number',
            label: 'Charge Amount',
            model: 'billingDetails.recurring[].charges.amount',
            validation: 'required|min:0',
            class: 'col-12 col-md-4',
            conditions: { field: 'billingDetails.billingType', value: 'RECURRING' },
            repeat: true
          },
          {
            type: 'text',
            form_type: 'text',
            label: 'Charge Label',
            model: 'billingDetails.recurring[].charges.label',
            validation: 'required',
            class: 'col-12 col-md-4',
            conditions: { field: 'billingDetails.billingType', value: 'RECURRING' },
            repeat: true
          },
          {
            type: 'select',
            form_type: 'select',
            label: 'Charge Basis',
            model: 'billingDetails.recurring[].chargeBasis',
            validation: 'required',
            class: 'col-12 col-md-4',
            options: [
              { value: 'PER_USER', label: 'Per User' },
              { value: 'PER_POLICY', label: 'Per Policy' },
              { value: 'PER_PERIOD', label: 'Per Period' }
            ],
            conditions: { field: 'billingDetails.billingType', value: 'RECURRING' },
            repeat: true
          },
          {
            type: 'select',
            form_type: 'select',
            label: 'Frequency Unit',
            model: 'billingDetails.recurring[].frequency.periodUnit',
            validation: 'required',
            class: 'col-12 col-md-6',
            options: [
              { value: 'DAY', label: 'Day' },
              { value: 'WEEK', label: 'Week' },
              { value: 'MONTH', label: 'Month' },
              { value: 'YEAR', label: 'Year' }
            ],
            conditions: { field: 'billingDetails.billingType', value: 'RECURRING' },
            repeat: true
          },
          {
            type: 'number',
            form_type: 'number',
            label: 'Frequency Period',
            model: 'billingDetails.recurring[].frequency.period',
            validation: 'required|min:1',
            class: 'col-12 col-md-6',
            conditions: { field: 'billingDetails.billingType', value: 'RECURRING' },
            repeat: true
          },
          {
            type: 'number',
            form_type: 'number',
            label: 'Intro Charge Amount',
            model: 'billingDetails.tiered.intro[].charges.amount',
            validation: 'required|min:0',
            class: 'col-12 col-md-4',
            conditions: { field: 'billingDetails.billingType', value: 'TIERED' },
            repeat: true
          },
          {
            type: 'text',
            form_type: 'text',
            label: 'Intro Charge Label',
            model: 'billingDetails.tiered.intro[].charges.label',
            validation: 'required',
            class: 'col-12 col-md-4',
            conditions: { field: 'billingDetails.billingType', value: 'TIERED' },
            repeat: true
          },
          {
            type: 'select',
            form_type: 'select',
            label: 'Intro Charge Basis',
            model: 'billingDetails.tiered.intro[].chargeBasis',
            validation: 'required',
            class: 'col-12 col-md-4',
            options: [
              { value: 'PER_USER', label: 'Per User' },
              { value: 'PER_POLICY', label: 'Per Policy' },
              { value: 'PER_PERIOD', label: 'Per Period' }
            ],
            conditions: { field: 'billingDetails.billingType', value: 'TIERED' },
            repeat: true
          },
          {
            type: 'select',
            form_type: 'select',
            label: 'Intro Period Unit',
            model: 'billingDetails.tiered.intro[].period.periodUnit',
            validation: 'required',
            class: 'col-12 col-md-6',
            options: [
              { value: 'DAY', label: 'Day' },
              { value: 'WEEK', label: 'Week' },
              { value: 'MONTH', label: 'Month' },
              { value: 'YEAR', label: 'Year' }
            ],
            conditions: { field: 'billingDetails.billingType', value: 'TIERED' },
            repeat: true
          },
          {
            type: 'number',
            form_type: 'number',
            label: 'Intro Period',
            model: 'billingDetails.tiered.intro[].period.period',
            validation: 'required|min:1',
            class: 'col-12 col-md-6',
            conditions: { field: 'billingDetails.billingType', value: 'TIERED' },
            repeat: true
          },
          {
            type: 'number',
            form_type: 'number',
            label: 'After Charge Amount',
            model: 'billingDetails.tiered.after[].charges.amount',
            validation: 'required|min:0',
            class: 'col-12 col-md-4',
            conditions: { field: 'billingDetails.billingType', value: 'TIERED' },
            repeat: true
          },
          {
            type: 'text',
            form_type: 'text',
            label: 'After Charge Label',
            model: 'billingDetails.tiered.after[].charges.label',
            validation: 'required',
            class: 'col-12 col-md-4',
            conditions: { field: 'billingDetails.billingType', value: 'TIERED' },
            repeat: true
          },
          {
            type: 'select',
            form_type: 'select',
            label: 'After Charge Basis',
            model: 'billingDetails.tiered.after[].chargeBasis',
            validation: 'required',
            class: 'col-12 col-md-4',
            options: [
              { value: 'PER_USER', label: 'Per User' },
              { value: 'PER_POLICY', label: 'Per Policy' },
              { value: 'PER_PERIOD', label: 'Per Period' }
            ],
            conditions: { field: 'billingDetails.billingType', value: 'TIERED' },
            repeat: true
          },
          {
            type: 'select',
            form_type: 'select',
            label: 'After Frequency Unit',
            model: 'billingDetails.tiered.after[].frequency.periodUnit',
            validation: 'required',
            class: 'col-12 col-md-6',
            options: [
              { value: 'DAY', label: 'Day' },
              { value: 'WEEK', label: 'Week' },
              { value: 'MONTH', label: 'Month' },
              { value: 'YEAR', label: 'Year' }
            ],
            conditions: { field: 'billingDetails.billingType', value: 'TIERED' },
            repeat: true
          },
          {
            type: 'number',
            form_type: 'number',
            label: 'After Frequency Period',
            model: 'billingDetails.tiered.after[].frequency.period',
            validation: 'required|min:1',
            class: 'col-12 col-md-6',
            conditions: { field: 'billingDetails.billingType', value: 'TIERED' },
            repeat: true
          },
          {
            type: 'radio',
            form_type: 'radio',
            label: 'Is Renewable',
            model: 'isRenewable',
            validation: 'required',
            class: 'col-12 col-md-6',
            options: [
              { value: true, label: 'True' },
              { value: false, label: 'False' }
            ]
          },
          {
            type: 'radio',
            form_type: 'radio',
            label: 'Is Discountable',
            model: 'isDiscountable',
            validation: 'required',
            class: 'col-12 col-md-6',
            options: [
              { value: true, label: 'True' },
              { value: false, label: 'False' }
            ]
          },
          {
            type: 'number',
            form_type: 'number',
            label: 'Plan Discount',
            model: 'planDiscount',
            validation: 'required|min:0',
            class: 'col-12 col-md-6',
            conditions: { field: 'isDiscountable', value: true }
          },
          {
            type: 'textarea',
            form_type: 'text',
            label: 'Features',
            model: 'features',
            validation: 'required|min:10|max:500',
            class: 'col-12'
          }
        ]
      }
    ]
  },
  table: {
    title: 'Pricing Plans',
    subtitle: 'A list of configured insurance service plans',
    table_fields: [
      { name: 'Name', align: 'l' },
      { name: 'Description', align: 'l' },
      { name: 'Type', align: 'c' },
      { name: 'User Type', align: 'c' },
      { name: 'Renewable', align: 'c' },
      { name: 'Cancelable', align: 'c' },
      { name: 'Discount', align: 'l' },
      { name: 'Discountable', align: 'c' },
      { name: 'actions', align: 'c' }
    ],
    searchFields: ['planName', 'planDescription', 'planType', 'planUserType'],
    rowData: [
      { type: 'text', field: 'planName', class: 'left bolder' },
      { type: 'text', field: 'planDescription', class: 'left bolder small' },
      { type: 'text', field: 'planType', class: 'left bolder' },
      { type: 'text', field: 'planUserType', class: 'left bolder' },
      { type: 'text', field: 'isRenewable', class: 'left bolder' },
      { type: 'text', field: 'isCancelable', class: 'left bolder' },
      { type: 'text', field: 'planDiscount', class: 'left bolder small' },
      { type: 'text', field: 'isDiscountable', class: 'left bolder' },
      {
        type: 'action',
        field: 'name',
        class: 'center',
        icon: '',
        actions: [
          {
            type: 'menu',
            title: 'View',
            event: 'servicecategory:view',
            icon: 'ico-reply',
            params: [{ key: 'service_category', field: '*' }]
          }
        ]
      }
    ]
  }
};